import { type Options } from '@contentful/rich-text-react-renderer'
import {
	BLOCKS,
	INLINES,
	type Block,
	type Inline,
} from '@contentful/rich-text-types'
import { type ReactNode } from 'react'

const CONTENTFUL_ENTRY_WHITE_DIAMOND_ON_BLACK = 'YmUviKjZ0uZEAR5yfsTI4'
const CONTENTFUL_ENTRY_FOUR_DIAMONDS = '5fIsHRGdqhD0X1Ii6EOVwl'

export const getRenderOptionsForSpc = (): Options => {
	return {
		renderText: (text: string) => {
			return text
				.split('\n')
				.reduce<ReactNode[]>((children, textSegment, index) => {
					return [...children, index > 0 && <br key={index} />, textSegment]
				}, [])
		},
		renderNode: {
			[BLOCKS.LIST_ITEM]: (_node: Block | Inline, children: ReactNode) => {
				return <li className="pl-2 [&>p]:inline">{children}</li>
			},
			[BLOCKS.OL_LIST]: (_node: Block | Inline, children: ReactNode) => {
				return <ol className="list-decimal pl-4">{children}</ol>
			},
			[BLOCKS.UL_LIST]: (_node: Block | Inline, children: ReactNode) => {
				return <ul className="list-disc pl-4">{children}</ul>
			},
			[INLINES.HYPERLINK]: (node: Block | Inline, children: ReactNode) => {
				return (
					// According to Claude noopener prevents the security risk of setting _blank without noreferrer.
					// We want to keep the referrer so that the customer can se that the user came from us.
					// eslint-disable-next-line react/jsx-no-target-blank
					<a href={node.data.uri} target="_blank" rel="noopener">
						{children}
					</a>
				)
			},
			[INLINES.EMBEDDED_ENTRY]: (
				node: Block | Inline,
				_children: ReactNode,
			) => {
				const id = node.data.target?.sys?.id

				if (!id) {
					return (
						<p className="text-red-500">Entry not found. Is it published?</p>
					)
				}

				if (id === CONTENTFUL_ENTRY_WHITE_DIAMOND_ON_BLACK) {
					return (
						<svg
							className="inline align-text-bottom"
							width="20"
							height="20"
							version="1.1"
							viewBox="0 0 100 100"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="m0.070423 49.789 49.93-49.789 50 50-50 50-50-50z"
								fill="currentColor"
							/>
							<path
								d="m50 90-25.692-25.61 15.692-14.39-17-19 7-6 20 22 20-22 7 6-17 19 15.709 15.132z"
								className="fill-white dark:fill-gray-800"
							/>
						</svg>
					)
				}

				if (id === CONTENTFUL_ENTRY_FOUR_DIAMONDS) {
					return (
						<svg
							className="inline align-text-bottom"
							width="20"
							height="20"
							viewBox="0 0 100 100"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M50 1 L72 23 L50 45 L28 23 Z" fill="currentColor" />
							<path d="M23 28 L45 50 L23 72 L1 50 Z" fill="currentColor" />
							<path d="M77 28 L99 50 L77 72 L55 50 Z" fill="currentColor" />
							<path d="M50 55 L72 77 L50 99 L28 77 Z" fill="currentColor" />
						</svg>
					)
				}

				return <span>▼</span>
			},
		},
	}
}
